import {
    PaymentReportModel
} from '@spa/api';

import {ReportTableColumn, ReportTableConfigInterface, ReportTableData} from '../../../app/shared/components';

export const ClientsEditPaymentsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: PaymentReportModel.getPaymentStatusSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getAmountSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getCurrenyCodeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getPaymentProcessSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getPaymentMethodSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getSettledDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getCreatedBySelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const ClientsEditPaymentsDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Status',
            selector: PaymentReportModel.getPaymentStatusSelector(),
        }),
        new ReportTableColumn({
            label: 'Account',
            selector: PaymentReportModel.getAccountReferenceIdSelector(),
        }),
        new ReportTableColumn({
            label: 'Amount',
            selector: PaymentReportModel.getAmountSelector(),
        }),
        new ReportTableColumn({
            label: 'Currency',
            selector: PaymentReportModel.getCurrenyCodeSelector(),
        }),
        new ReportTableColumn({
            label: 'Type',
            selector: PaymentReportModel.getPaymentProcessSelector(),
        }),
        new ReportTableColumn({
            label: 'Method',
            selector: PaymentReportModel.getPaymentMethodSelector(),
        }),
        new ReportTableColumn({
            label: 'Date',
            selector: PaymentReportModel.getDateSelector(),
        }),
        new ReportTableColumn({
            label: 'Settled',
            selector: PaymentReportModel.getSettledDateSelector(),
        }),
        new ReportTableColumn({
            label: 'Created By',
            selector: PaymentReportModel.getCreatedBySelector()
        })
    ],
    hiddenColumnIds: [],
    actionMenu: false
};
